import React from 'react';
import { Link } from 'react-router-dom';
import { faWandMagicSparkles, faLaptopCode, faRocket } from '@fortawesome/free-solid-svg-icons';
import {
  AppUdviklingPage,
} from './Appudvikling.styled';
import NavBarDiff from '../NavBarDiff';
import {
  Section,
  MainBtn, FeaturesImgLeft
} from '../Styled';
import { SweetBox } from '../blocks/Sweetbox.styled';

import PLACEHOLDERIMG from '../images/app_mockups_showcase.png';
import ImgPlaceholder from '../images/nye_designs_img.png';
import ReactImg from '../images/react_img.png';
import Slider from '../blocks/Slider';
import Footer from '../blocks/Footer';
import Features from '../blocks/Features';
import CTAUp from '../blocks/CTAUp';
import APPMOCKUPS from '../images/cases-img.png';
import UdviklingSection from './UdviklingSection';
import { AppVideo } from './Cases.syled';
import VIDEO from '../images/movie_database_danish_copy.mp4';

const CARDS = [
  {
    id: 0,
    source: ImgPlaceholder,
    title: 'Administrativt Dashboard',
    text: 'Vi giver dig mulighed for at se data, indsamle indsigt og udføre helpdesk-opgaver.',
  },
  {
    id: 1,
    source: ImgPlaceholder,
    title: 'Program- og serverkodebaser',
    text: 'Vi etablerer din intellektuelle ejendom, hostet på Github, BitBucket eller GitLab.',
  },
  {
    id: 2,
    source: ImgPlaceholder,
    title: 'App Store & Play Store',
    text: 'Vi guider app-indsendelse og accept. Vi sørger også for at bygge din App Store-side.',
  },
  {
    id: 3,
    source: ImgPlaceholder,
    title: 'High-Fidelity-design',
    text: 'Vi skaber et pixel-perfekt skelet af applikationsoplevelsen.',
  },
  {
    id: 4,
    source: ImgPlaceholder,
    title: 'Vedligeholdelse',
    text: 'Efter launchering af din App, tilbyder vi vedligeholdelse i det næste år.',
  },
];

const IconCARDS = [
  {
    title: 'Fremtidssikret',
    text: 'Vi udvikler din App i det sidste nye framework.',
    id: 0,
  },
  {
    title: 'API muligheder',
    text: 'Vi kan integrere API kald på de bedste måder.',
    id: 1,
  },
  {
    title: 'Mindst krævende',
    text: 'Vi optimere koden, så der bruges mindst muligt CPU.',
    id: 2,
  },
  {
    title: 'Intelligent',
    text: 'Vi laver en inteligent App som kan analysere data.',
    id: 3,
  },
]

const Appudvikling = () => {
  return (
    <AppUdviklingPage>
      <Section>
        <NavBarDiff />
        <CTAUp
          title='Kraftfuld løsning for dit startup'
          body='Med en app sender du et stærkt signal af seriøsitet og ambition.
        Det gør det så langt nemmere for folk at besøge dit domæne.'
          btn='Tag kontakt'
          to='/kontakt'
          photo={PLACEHOLDERIMG}
          alt='Apps'
        />
      </Section>
      <UdviklingSection
        title='Smart App udvikling'
        underTitle='En App koster både tid og resourcer at udvikle. Derfor kan det være en fordel at slå sig sammen med et bureau med ekspertise indenfor App udvikling.'
        lt1='Hastighedsoptimeret'
        pa1='Smart etablering af komponenter som sørger for Appen forbliver hurtig.'
        ic1={faWandMagicSparkles}
        lt2='Hybdrid App'
        pa2='Vi udvikler Appen som hybrid så den kan benyttes på Apple og android enheder.'
        ic2={faLaptopCode}
        lt3='Launchering'
        pa3='Vi har udviklerrettigheder hos både Apple og Android og kan let launchere din App.'
        ic3={faRocket}
      />
      <Slider CARDS={CARDS} />
      <CTAUp
        title='Udvikling af apps til Android og iOS.'
        body='Det er en kompleks og krævende proces at udvikle en app. Derfor er vi ofte med i processen i et meget tidligt stadie. Vores ekspertise, input og erfaring kan være afgørende for din succes.'
        btn={null}
        photo={APPMOCKUPS}
        alt='Placeholder'
      />
      <Features
        CARDS={IconCARDS}
        title='Software og mobil udvikling'
        body='Oprettelse af tilpasset software og mobilapplikationer, der hjælper vores kunder med at nå de mest ambitiøse mål.'
      />
      <Section>
        <SweetBox>
          <div>
            <h1>Skal vi lave et estimat på dit projekt?</h1>
            <p>
              Udfyld vores kontaktformular og hør tilbage fra os inden for de næste 24 timer
            </p>
            <Link to='/kontakt#formular'>
              <MainBtn>Estimér projekt</MainBtn>
            </Link>
          </div>
          <div>
            <AppVideo src={VIDEO} frameBorder="0" title='Film database App' autoPlay loop />
          </div>
        </SweetBox>
      </Section>
      <FeaturesImgLeft>
        <div>
          <img src={ReactImg} alt="React" />
        </div>
        <div>
          <h1>virksomheds</h1>
          <h2>Softwareudvikling</h2>
          <p>
            Uanset branchesegmentet har du brug for pålidelig software.
            Her hos Noaly udvikler vi en skræddersyet software passende til din virksomhed,
            så den kunne opfylde dine behov og bringe nye muligheder, som før var udenfor rækkevidde <br /> <br />
            Vi koder primært Apps i React Native.
          </p>
        </div>
      </FeaturesImgLeft>
      <Footer />
    </AppUdviklingPage>
  );
};

export default Appudvikling;
